import { Grid, Card, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { dataAnalyticsCards } from '../utils/cardJson';

const DataAnalyticsCards = () => {
  const navigate = useNavigate();

  return (
    <Grid container spacing={2}>
      {dataAnalyticsCards.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card
            onClick={() => navigate(item.path)}
            sx={{
              cursor: 'pointer',
              minHeight: 130,
              height: '100%',
              borderRadius: 3,
              color: '#fff',
              position: 'relative',
              overflow: 'hidden',

              // 🎨 Gradient background
              background: 'linear-gradient(135deg, #667eea, #764ba2)',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',

              transition: 'all 0.3s ease',

              '&:hover': {
                transform: 'translateY(-6px) scale(1.03)',
                boxShadow: '0 12px 30px rgba(0,0,0,0.2)',
              },

              // subtle overlay glow
              '&::after': {
                content: '""',
                position: 'absolute',
                width: '200%',
                height: '200%',
                top: '-50%',
                left: '-50%',
                background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 60%)',
                opacity: 0,
                transition: '0.3s',
              },

              '&:hover::after': {
                opacity: 1,
              },
            }}
          >
            <CardContent>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  lineHeight: 1.4,
                  letterSpacing: '0.3px',
                }}
              >
                {item.title}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DataAnalyticsCards;
